import React from "react";
import "./LoadingSpinner.css";
import Loaderimg from "../../../assets/images/Xeroxloader.gif";// 


export default function LoadingSpinner() {
  return (
      <div className="text-center customLoader">
        <div className="loader-centered">
          <img src={Loaderimg}  alt="Loading" className="customChailedLoader"></img>
        </div>
        <div className="spinningTextDiv">
        <div className="RobotoFont spinningText">
          Loading your document. Please wait.
        </div>
      </div>
      </div>
  );
}